"use client"

import { useState } from "react"
import Link from "next/link"
import { MarkdownConverter } from "@/components/markdown-converter"

export default function Home() {
  const [hasFile, setHasFile] = useState(false)

  return (
    <main className="min-h-screen bg-background py-12 px-4 print:p-0">
      <div className="max-w-[1600px] mx-auto w-full">
        <div className="mb-8 no-print">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-3xl font-bold tracking-tight mb-4">
              Convert Markdown to PDF with Logo, Custom Header and Footer
            </h1>
            {!hasFile && (
              <div className="space-y-3 text-muted-foreground">
                <p>
                  Convert Markdown to PDF with custom header and footer easily in your browser.
                </p>
                <p>
                  You can also insert a manual page break by adding &lt;!-- pagebreak --&gt; in your Markdown file.
                </p>
              </div>
            )}
          </div>
        </div>
        <MarkdownConverter onFileChange={setHasFile} />
      </div>

      <footer className="mt-12 pt-8 border-t no-print">
        <div className="max-w-[1600px] mx-auto w-full px-4 flex justify-center gap-6">
          <a
            href="https://raw-fi-data.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-muted-foreground hover:underline"
          >
            About Us
          </a>
          <Link href="/privacy" className="text-sm text-muted-foreground hover:underline">
            Privacy Policy
          </Link>
        </div>
      </footer>
    </main>
  )
}
